const openModeEnum = {
    NewTab: "NewTab",
    SameWindow: "SameWindow",
};

export default openModeEnum;
